import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Bank, Lock } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { PayDebtAction } from "@/components/Molecules";
import { formatPersianNumber } from "@/lib/format/persian";
import type { CommissionBannerProps } from "./CommissionBanner.types";
import * as styles from "./CommissionBanner.styles";

export type { CommissionBannerProps, CommissionBannerView } from "./CommissionBanner.types";

export const CommissionBanner = memo(function CommissionBanner({ view }: CommissionBannerProps) {
  const { t } = useTranslation("commission");
  const theme = useTheme();
  const toneColor = theme.palette[view.tone].main;
  const isRestricted = view.variant === "restricted";

  return (
    <Box sx={styles.root(view.tone)}>
      <Box sx={styles.iconWrap(view.tone)}>
        {isRestricted ? (
          <Lock size={20} variant="Bold" color={toneColor} />
        ) : (
          <Bank size={20} variant="Bold" color={toneColor} />
        )}
      </Box>

      <Box sx={styles.content}>
        <Typography sx={styles.message(view.tone)}>
          {t(isRestricted ? "banner.restricted" : "banner.noIban")}
        </Typography>
        <Typography sx={styles.metaText}>
          {view.variant === "restricted"
            ? t("banner.debtAmount", {
                amount: formatPersianNumber(view.outstandingDebt),
                limit: formatPersianNumber(view.debtLimit),
              })
            : t("banner.noIbanHint")}
        </Typography>
      </Box>

      {view.variant === "restricted" ? (
        <PayDebtAction canPayDebt={view.canPayDebt} size="small" />
      ) : (
        <PayDebtAction
          canPayDebt
          to="/settings"
          intent="secondary"
          label={t("actions.addIban")}
          size="small"
        />
      )}
    </Box>
  );
});
